import React from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import CompareInterest from "./components/CompareInterests";
import CompareSkill from "./components/CompareSkill";
import CompleteQuestionnaire from "./components/CompleteQuestionnaire";
import GlobalStyle from "./components/GlobalStyles"; // Import GlobalStyle
import Interests from "./components/Interests";
import Layout from "./components/Layout";
import NotFound from "./components/NotFound";
import Result from "./components/Result";
import Skills from "./components/Skill";

function App() {
  return (
    <Router>
      <GlobalStyle /> {/* Use GlobalStyle */}
      <Routes>
        <Route
          path="/results/:attemptId"
          element={
            <Layout>
              <Result />
            </Layout>
          }
        />
        <Route
          path="/interests/:attemptId"
          element={
            <Layout>
              <Interests />
            </Layout>
          }
        />
        <Route
          path="/compare_interests/:attemptId/:voucherId"
          element={
            <Layout>
              <CompareInterest />
            </Layout>
          }
        />
        <Route
          path="/compare_skill/:attemptId/:voucherId"
          element={
            <Layout>
              <CompareSkill />
            </Layout>
          }
        />
        <Route
          path="/skills/:attemptId"
          element={
            <Layout>
              <Skills />
            </Layout>
          }
        />
        <Route
          path="/"
          element={
            <Layout>
              <CompleteQuestionnaire />
            </Layout>
          }
        />
        <Route
          path="*"
          element={
            <Layout>
              <NotFound />
            </Layout>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
